export default "__VITE_ASSET__DP$fLrnE__"